import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import {
  type SimpleAlertOptions,
  SimpleAlertOptionsDefaults,
} from '../simple-ui.service';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

export interface SimpleAlertDialogData {
  options: SimpleAlertOptions;
  promptForInput?: boolean;
}

/**
 * Closes with 'ok' (alert), the entered text (prompt), or undefined (cancel).
 */
@Component({
  selector: 'app-simple-alert',
  standalone: true,
  imports: [FormsModule, MatDialogModule, MatFormFieldModule, MatInputModule],
  templateUrl: './simple-alert.component.html',
  styleUrl: './simple-alert.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleAlertComponent {
  private readonly data = inject<SimpleAlertDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject<MatDialogRef<SimpleAlertComponent, string | undefined>>(MatDialogRef);

  options = signal<SimpleAlertOptions>(this.data.options ?? SimpleAlertOptionsDefaults);
  promptForInput = signal(this.data.promptForInput ?? false);
  inputText = signal(this.data.options?.defaultInput ?? '');

  okDisabled = computed(() => {
    return this.promptForInput() && this.inputText().length === 0;
  });

  public ok() {
    this.dialogRef.close(this.promptForInput() ? this.inputText() : 'ok');
  }

  public cancel() {
    this.dialogRef.close(undefined);
  }
}
